import TemplateNames from '../email-messages/TemplateNames';
import MarketingSubscriptionSources from '../followers/MarketingSubscriptionSources';

export default {
  title: 'Aperçu marketing',
  tiles: {
    followers: 'Abonnés',
    delivered_messages: 'Messages délivrés',
    open_rate: "Taux d'ouverture",
    click_rate: 'Taux de clic',
    spam_report_rate: 'Taux de signalement spam',
    unsubscribe_rate: 'Taux de désabonnement',
  },
  subscriprion_sources_table: {
    source_names: MarketingSubscriptionSources,
    columns: {
      subscription_source: "Source d'abonnement",
      count: 'Nombre',
      percentage: 'Pourcentage',
    },
  },
  templates_table: {
    template_names: TemplateNames,
    columns: {
      template: 'Modèle',
      delivered: 'Délivré',
      open_rate: "Taux d'ouverture",
      click_rate: 'Taux de clic',
      spam_report_rate: 'Taux de signalement spam',
      unsubscribe_rate: 'Taux de désabonnement',
    },
  },
  labels: {
    no_data: 'Aucune donnée',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
